import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import eapIcon from '../../assets/eap-icon.png';

interface BrainMarkProps {
  size?: number;
  sx?: SxProps<Theme>;
}

const BrainMark: React.FC<BrainMarkProps> = ({ size = 40, sx }) => (
  <Box
    component="img"
    src={eapIcon}
    alt="eap CONSULTING"
    sx={[
      {
        width: size,
        height: size,
        borderRadius: '18%',
        display: 'block',
        objectFit: 'cover',
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  />
);

export default BrainMark;
